import React, { useEffect, useState } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';

const HelpContent = ({ moduleId, locale }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading');
  const [raw, setRaw] = useState('');

  useEffect(() => {
    if (!moduleId || !locale) return;
    let cancelled = false;
    setStatus('loading');
    setRaw('');
    const url = `${process.env.PUBLIC_URL || ''}/help/${locale}/${moduleId}.md`;
    fetch(url, { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.text();
      })
      .then((text) => {
        if (!cancelled) {
          setRaw(text);
          setStatus('ready');
        }
      })
      .catch((err) => {
        console.error('[HelpContent] failed to load', url, err);
        if (!cancelled) setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, [moduleId, locale]);

  if (status === 'loading') {
    return (
      <div className="text-center py-5" data-testid="help-content-loading">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">{t('common.loading', 'Cargando...')}</span>
        </Spinner>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <Alert variant="warning" className="mt-3" data-testid="help-content-error">
        <Alert.Heading>
          <i className="bi bi-exclamation-triangle me-2" aria-hidden="true"></i>
          {t('help.loadingErrorTitle', 'No pudimos cargar la sección')}
        </Alert.Heading>
        <p className="mb-0">
          {t(
            'help.loadingError',
            'Puede que el módulo no exista o tenga problemas temporales. Intenta de nuevo o elige otro módulo.'
          )}
        </p>
      </Alert>
    );
  }

  return (
    <article className="help-content-article" data-testid="help-content-ready">
      <ReactMarkdown>{raw}</ReactMarkdown>
    </article>
  );
};

export default HelpContent;
